export default {
    raiz: 'https://universidadmaderas.com/buniversity/index.php/'
};
